
import React, { useState } from 'react'

export const EmbarazadaNameCmp = ({ addEmbName }) => {
  const [embname, setEmbName] = useState('')
  function onChangeInput(event) {
    setEmbName(event.target.value)
  }

  function handlerContinuar(embname) {
    addEmbName(embname)
  }


  const handleKeyPress = (event) => {
    if (event.key === 'Enter') {
      handlerContinuar(event.target.value);
    }
  };

  return (
    <div style={{ marginTop: '-60%'}}>
      <h1 className="text-2xl font-bold mb-1">Cual es tu nombre?</h1>
      <p className='mb-8'>Nombre de la embarazada</p>
      <div className="flex flex-col items-center">
        
          <input type="text" className="input input-bordered input-lg w-full max-w-xs" placeholder="Escribe aquí tu respuesta..." value={embname} onChange={onChangeInput} onKeyDown={handleKeyPress}/>
        
        <button disabled={embname ? false : true} className="btn btn-primary mt-5" onClick={()=>handlerContinuar(embname)}>Continuar</button>
      </div>
    </div>
  )
}